export default "__VITE_ASSET__acfa4bba__"